module.exports = __webpack_public_path__ + "img/bullet_13.01608f17.svg";